"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Ul = (0, _material.styled)('ul')(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    listStyle: 'none'
  };
});
var Li = (0, _material.styled)('li')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    borderBottomColor: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& spam': {
      display: 'block',
      width: '100%'
    },
    '& small': {
      display: 'block'
    },
    '&:last-child': {
      borderBottomWidth: 0
    }
  };
});
function TransitionableOwnerBadge(_ref3) {
  var tenantId = _ref3.tenantId,
    id = _ref3.id,
    getPromise = _ref3.getPromise;
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    owners = _useState4[0],
    setOwners = _useState4[1];
  var retrievePromise = (0, _react.useCallback)(function () {
    if (id) {
      return getPromise(tenantId, id);
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, id, getPromise]);
  var listBuilder = (0, _react.useCallback)(function (data) {
    return data ? /*#__PURE__*/_react["default"].createElement(Ul, null, data.owners.map(function (el) {
      return /*#__PURE__*/_react["default"].createElement(Li, {
        key: el.id
      }, /*#__PURE__*/_react["default"].createElement("span", null, el.name), /*#__PURE__*/_react["default"].createElement("small", null, (0, _core.translate)("transitionable_owners.type.".concat(el.type))));
    })) : undefined;
  }, []);
  (0, _react.useEffect)(function () {
    setStatus('loading');
    retrievePromise().then(function (response) {
      if (response === null || response === void 0 ? void 0 : response.owners.length) {
        setOwners(listBuilder(response));
      } else {
        setOwners(undefined);
      }
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error);
      setOwners(error.message);
    });
  }, [retrievePromise, listBuilder]);
  return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: owners !== null && owners !== void 0 ? owners : (0, _core.translate)('transitionable_owners.empty'),
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    sx: function sx(theme) {
      return {
        bgcolor: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white
      };
    }
  }, status === 'loading' ? /*#__PURE__*/_react["default"].createElement(_commons.Progress, null) : /*#__PURE__*/_react["default"].createElement(_commons.UsersIcon, {
    color: status === 'loaded' ? 'action' : 'error'
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TransitionableOwnerBadge);